<template>
  <div
    data-cy="thread-icon"
    class="relative flex h-6 w-6 flex-none items-center justify-center rounded-full"
    :class="iconInfo.backgroundClass"
  >
    <icon-base
      :icon="iconInfo.icon"
      class="text-white"
      :height="iconInfo.height ?? 12"
      :width="iconInfo.width ?? 12"
      :view-box="iconInfo.viewBox"
    />
    <div
      v-if="
        iconInfo.isOutgoing !== undefined ||
        iconInfo.contextIcon ||
        iconInfo.providerIcon
      "
      class="absolute -right-1.5 -bottom-1 flex h-3.5 w-3.5 items-center justify-center rounded-full border border-white"
      :class="bgClass"
    >
      <icon-base
        v-if="iconInfo.isOutgoing !== undefined"
        :icon="IconIncomingArrow"
        height="6"
        width="6"
        viewBox="0 0 12 12"
        class="!mb-0 text-white"
        :class="{ 'rotate-180 transform': iconInfo.isOutgoing }"
      />
      <icon-base
        v-else-if="iconInfo.contextIcon"
        :icon="iconInfo.contextIcon"
        height="6"
        width="6"
        viewBox="0 0 16 16"
        class="!mb-0 text-white"
      />
    </div>
    <div
      v-if="iconInfo.providerIcon"
      class="absolute -bottom-1 -left-1 h-3.5 w-3.5"
    >
      <img
        :src="`/images/${iconInfo.providerIcon}`"
        class="h-3.5"
        :class="iconInfo.providerIconClass"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { type Component, computed } from "vue";

import { CommunicationType } from "@/enums/communicationLogs";

import IconIncomingArrow from "@/components/icons/IconIncomingArrow.vue";
import IconTelephone from "@/components/icons/IconTelephone.vue";
import IconBase from "@/components/ui/IconBase.vue";

const { iconInfo } = defineProps<{
  iconInfo: {
    icon: Component;
    backgroundClass: string;
    viewBox: string;
    isOutgoing?: boolean;
    height?: number;
    width?: number;
    type?: CommunicationType;
    contextIcon?: Component;
    providerIcon?: SVGElement;
    providerIconClass?: string;
  };
}>();

const bgClass = computed(() => {
  if (iconInfo.type === CommunicationType.call) {
    return iconInfo.isOutgoing ? "bg-primary" : "bg-turquoise";
  }
  if (iconInfo.type === CommunicationType.note) {
    return iconInfo.contextIcon === IconTelephone
      ? "bg-woods-green"
      : "bg-secondary-purple-1";
  }
  return iconInfo.isOutgoing ? "bg-primary" : "bg-turquoise";
});
</script>
